//Models

import { GetDataFilesDataFileGetParams, GetDatasetsDatasetGetParams, GetModelFamiliesModelFamilyGetParams } from "../api/models";
import { FilterBarType } from "../components/Filtering/FilterBar";

export const modelStats = [
    'auc',
    'f1score', 
    'precision',
    'recall',
    'acc',
    'specificity',
    'cohens_kappa',
    'mcc',
    'mgd',
    'mpd',
    'mae',
    'rmse',
    'r2'
];

export const classificationMethods = [
    'MLPClassifier',
    'RandomForestClassifier',
    'BernoulliNB',
    'AdaBoostClassifier',
    'SVC',
    'KNeighborsClassifier',
    'XGBClassifier',
    'LogisticRegression',
]

export const classificationMethodMapping = {
    MLPClassifier: 'DL',
    RandomForestClassifier: 'rf',
    BernoulliNB: 'bnb',
    AdaBoostClassifier: 'ada',
    SVC: 'svc',
    KNeighborsClassifier: 'knn',
    XGBClassifier: 'xgb',
    LogisticRegression: 'lreg'
}

export const regressionMethods = [
    'AdaBoostRegressor',
    'BayesianRidge',
    'XGBRegressor',
    'ElasticNet',
    'RandomForestRegressor',
    'KNeighborsRegressor',
    'SVR',
];

export const regressionMethodMapping = {
    AdaBoostRegressor: 'adar',
    ADABoostRegressor: 'adar',
    BayesianRidge: 'br',
    XGBRegressor: 'xgbr',
    ElasticNet: 'enr',
    RandomForestRegressor: 'rfr',
    KNeighborsRegressor: 'knnr',
    SVR: 'svr',
}

export const exportFileExtensions = [
    { label: 'XLSX', file_type: '.xlsx' },
    { label: 'CSV', file_type: '.csv' },
    { label: 'SDF', file_type: '.sdf' },
    { label: 'Parquet', file_type: '.parquet' },
]

export const allMethods = classificationMethods.concat(regressionMethods);

export const modelStatLimits = [
    {
        value: 'auc',
        min: 0,
        max: 1,
    },
    {
        value: 'f1score',
        min: 0,
        max: 1,
    },
    {
        value: 'precision',
        min: 0,
        max: 1,
    },
    {
        value: 'recall',
        min: 0,
        max: 1,
    },
    {
        value: 'acc',
        min: 0,
        max: 1,
    },
    {
        value: 'specificity',
        min: 0,
        max: 1,
    },
    {
        value: 'cohens_kappa',
        min: -1,
        max: 1,
    },
    {
        value: 'mcc',
        min: -1,
        max: 1,
    },
    {
        value: 'r2',
        min: 0,
        max: 1,
    }
  ];

  export const defaultModelParams: GetModelFamiliesModelFamilyGetParams = {
    name: null,
    created_by: null,
    owner: null,
    start_date: null,
    end_date: null,
    tag_groups: null,
    sort_by: 'creation_date',
    sort_order: 'desc',
    limit: 10,
    offset: 0,
    include_airflow_metadata: false,
  };

  export const getDatasetParams = (default_dataset_type?: string) => {
    const defaultParams: GetDatasetsDatasetGetParams = {
        name: null,
        created_by: null,
        owner: null,
        start_date: null,
        end_date: null,
        tag_groups: null,
        dataset_type: default_dataset_type === undefined ? undefined : default_dataset_type === 'structures-only' ? 'structures-only' : 'single-class-label',
        sort_by: 'creation_date',
        sort_order: 'desc',
        limit: 10,
        offset: 0,
        include_airflow_metadata: false,
    }

    return defaultParams;
  }

  export const defaultFileParams: GetDataFilesDataFileGetParams = {
      name: null,
      created_by: null,
      owner: null,
      start_date: null,
      end_date: null,
      tag_groups: null,
      sort_by: 'creation_date',
      sort_order: 'desc',
      offset: 0,
      limit: 10,
  }

  export const defaultFilters: FilterBarType[] = [
      {
          label: 'Created Date Range',
          param: 'start_date',
          type: 'date-range',
          isDefault: true,
          groupKey: 'date-range',
      },
      {
          label: 'Created Date Range',
          param: 'end_date',
          type: 'date-range',
          isDefault: true,
          groupKey: 'date-range',
      },
      {
          label: 'Tags',
          param: 'tag_groups',
          type: 'tags',
          isDefault: true,
      },
      {
          label: 'Created By',
          param: 'created_by',
          type: 'users',
          isDefault: true,
      },
      {
          label: 'Owner',
          param: 'owner',
          type: 'users',
          isDefault: true,
      },
  ];